import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const InfoModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="Jak hrát České Wordle" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Uhodněte české slovo – podstatné jméno v prvním pádě bez diakritiky – na 6 pokusů.
        Po každém pokusu se změní barva každého políčka pro znázornění,
        jak blízko byl Váš odhad k hádanému slovu.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="H" status="correct" />
        <Cell value="U" />
        <Cell value="D" />
        <Cell value="B" />
        <Cell value="A" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Písmeno H se ve nachází v hádaném slově a je na správném místě.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="P" />
        <Cell value="I" />
        <Cell value="L" status="present" />
        <Cell value="O" />
        <Cell value="T" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Písmeno L se nachází v hádaném slově, ale na špatném místě.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell value="L" />
        <Cell value="U" />
        <Cell value="C" />
        <Cell value="K" status="absent" />
        <Cell value="A" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
        Písmeno K se nenachází v hledaném slově na žádném místě.
      </p>
    </BaseModal>
  )
}
